'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.fullCalendar.service
 * @description
 * # fullCalendar.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('fullCalendarService', function (moment, momentService) {

    var fullCalendarService = {};

    fullCalendarService.getAvailableTimeOnDay = getAvailableTimeOnDay;
    fullCalendarService.getDefaultUIConfig = getDefaultUIConfig;
    fullCalendarService.getView = getView;
    fullCalendarService.goToDate = goToDate;
    fullCalendarService.changeView = changeView;

    return fullCalendarService;

    function getAvailableTimeOnDay(eventList, dayId, duration) {
      var daysEvents = eventList
        .filter(function (event) {
          return event.dayId === dayId;
        });

      var totalTime = daysEvents.reduce(function (cumulativeDuration, event) {
        return cumulativeDuration + event.duration;
      }, 0);

      var remainingWith = 7 - (totalTime + duration);
      var available = remainingWith >= 0;
      var remainingWithout = 7 - (totalTime);
      var remaining = available ? remainingWith : remainingWithout;

      var availableMoment = getAvailableMoment(daysEvents, duration, dayId);
      return {
        available: remainingWith >= 0,
        remaining: remaining,
        latestMoment: availableMoment
      };
    }

    function getDefaultUIConfig(customObjects) {
      var uiConfig = {
        calendar: {
          height: 450,
          editable: true,
          eventOverlap: false,
          eventConstraint: {
            start: '09:00',
            end: '16:00'
          },
          businessHours: {
            start: '09:00',
            end: '16:00'
          },
          header: {
            left: 'month agendaWeek agendaDay listWeek',
            center: 'title',
            right: 'prev,next'
          },
          minTime: '08:00:00',
          maxTime: '17:00:00',
          weekends: false,
          eventDurationEditable: false
        }
      };
      angular.extend(uiConfig.calendar, customObjects);
      return uiConfig;
    }

    function getView(calendar) {
      return calendar.fullCalendar('getView');
    }

    function changeView(calendar, view) {
      calendar.fullCalendar('changeView', view);
    }

    function goToDate(calendar, date) {
      calendar.fullCalendar('gotoDate', date);
    }

    function getAvailableMoment(daysEvents, duration, dayId) {
      var dayMoment = momentService.getMomentFromDayId(dayId);
      var firstSlotMoment = moment(dayMoment.clone().set({
        'hour': 9,
        'minute': 0,
        'second': 0
      }).format());

      if (!daysEvents.length) {
        return firstSlotMoment.clone();
      }


      var dayEnd = firstSlotMoment.clone().add(7, 'h');
      var latestStart = dayEnd.clone().subtract(duration, 'h');

      var slots = [firstSlotMoment];
      for (var i = 0; i < 13; i++) {
        var items = moment(firstSlotMoment.clone().add(30 * (i + 1), 'm').format());
        if (items.valueOf() <= latestStart.valueOf()) {
          slots.push(items);
        }
      }

      var space = slots
        .filter(function (valueStart) {
          var minutes = duration * 60;
          var valueEnd = moment(valueStart.clone().add(minutes , 'm').format());
          var overlapList = daysEvents
            .map(function (event) {
              var newEvent = {
                startMoment: valueStart,
                endMoment: valueEnd
              };
              return eventsOverlap(newEvent, event);
            });
          return overlapList.every(function (value) {
            return value === false;
          });
        });
      return space[0];
    }

    function eventsOverlap(newEvent, event) {
      var eventStartMoment = moment(event.start);
      var eventEndMoment = moment(event.end);

      var newEventStartMoment = newEvent.startMoment;
      var newEventEndMoment = newEvent.endMoment;

      if (newEventStartMoment.isSame(eventStartMoment)) {
        return true;
      }

      if (newEventStartMoment.isBefore(eventStartMoment)) {
        return !(newEventEndMoment.isSame(eventStartMoment) || newEventEndMoment.isBefore(eventStartMoment));
      }

      if (newEventStartMoment.isAfter(eventStartMoment)) {
        return !(newEventStartMoment.isSame(eventEndMoment) || newEventStartMoment.isAfter(eventEndMoment));
      }

      throw new Error('newEvent is not before same or after existing event');
    }
  });
